module.exports = __webpack_public_path__ + "img/bg-matching2.d28f3b21.gif";